import { Button, Container } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import errorGraphic from '../assets/svg/404-error-page.svg';
import withContentfulTag from '../hocs/withContentfulTag';
import type { ContentfulTagProps } from '../types/propTypes';
import OnboardingLayout from '../ui/Layout/OnboardingLayout';
import { min } from '../utils/breakpoints';

const StyledButton = styled(Button)`
  min-width: 198px;
`;

const RelativeDiv = styled.div`
  ${min.sm} {
    position: relative;
    top: -70px;
  }
`;

const StyledContainer = styled(Container)`
  max-width: 652px;
`;

const NotFoundContainer = ({
  contentful,
  loading,
  fetched,
}: Pick<ContentfulTagProps, 'contentful' | 'loading' | 'fetched'>) => {
  const navigate = useNavigate();
  return (
    !loading &&
    fetched && (
      <OnboardingLayout>
        <StyledContainer className="text-center pt-4">
          <img src={errorGraphic} alt="404 error page not found" />
          <RelativeDiv className="pb-3 pb-lg-1">
            <StyledButton onClick={() => navigate('/')}>{contentful?.primaryButtonText}</StyledButton>
            <h1 className="pb-2">{contentful?.subtitle}</h1>
            <ReactMarkdown>{contentful?.body ?? ''}</ReactMarkdown>
          </RelativeDiv>
        </StyledContainer>
      </OnboardingLayout>
    )
  );
};

export default withContentfulTag(NotFoundContainer, 'web_app_not_found_page');
